// Image imports
import naorSivanPhoto from '../../../images/naor_sivan_photo.png';

export const naorHasidimandsivanElkabetsMemorial = {
  id: 6,
  name: 'Naor Hasidim & Sivan Elkabets',
  category: 'young-lives',
  images: {
    couple: naorSivanPhoto
  },
  info: `

# Naor Hasidim & Sivan Elkabets

"There is a hole in my heart. I hope — I don't know if it will close. It is opening wider and wider and wider." - Avi Hasidim, Naor's father

![Naor and Sivan](${naorSivanPhoto})
*Naor Hasidim and Sivan Elkabets, a young couple whose lives were tragically cut short*

## A Love Story Cut Short

Naor Hasidim and Sivan Elkabets, both 23, had been together since they were 16 years old. Their love story, which began in their teenage years, was tragically ended on October 7, 2023, when Hamas militants attacked their home in Kibbutz Kfar Aza.

## Lives Full of Promise

Naor and Sivan were vibrant young adults with their whole lives ahead of them:

- Both had completed their military service
- They were living together in Kibbutz Kfar Aza
- Naor would have turned 24 on January 3, 2024

## The Tragic Day

On October 7, 2023, Hamas gunmen invaded Kfar Aza, one of the hardest-hit locations during the attack. Naor and Sivan were among the victims, killed in their own home.

## A Memorial in Bullet Holes

The couple's apartment now stands as a stark reminder of the violence that took their lives:

- Bullet holes and grenade shrapnel marks cover the walls
- Blood stains remain on the floor and sofa
- Inscriptions left by Israeli soldiers who cleared the area read "Human remains on the sofa"

## Remembering Naor and Sivan

Avi Hasidim, Naor's father, and Anati Elkabets, Sivan's mother, have turned the couple's bullet-riddled flat into a memorial:

- Photos of happy moments in the couple's lives are displayed alongside images documenting the aftermath of the attack
- The parents visit the apartment to mourn and to show visitors the displays they've arranged

Avi Hasidim shared a poignant memory of the couple at his eldest daughter's wedding, just four months before the attack:

> "How he danced, how she danced. How they hugged and kissed. How much they loved everyone and everyone loved them. These are the most beautiful memories in the world."

## Legacy

Naor and Sivan are now buried side by side in the city of Ashdod, about 50 km from Kfar Aza. Their story has become part of the larger narrative of the October 7 attacks, with their home potentially becoming one of the sites visited by those seeking to understand the events of that day.

As Israel grapples with how to memorialize the victims of October 7, the story of Naor and Sivan serves as a powerful reminder of the human cost of conflict and the enduring power of love in the face of tragedy.

[Read more about Naor and Sivan](https://www.timesofisrael.com/naor-hasidim-sivan-elkabets-23-together-since-they-were-16/)

[Learn about the ongoing memorialization efforts](https://www.haaretz.com/israel-news/2024-01-25/ty-article-magazine/.premium/on-your-right-a-massacre-site-oct-7-atrocities-tourists-are-inundating-southern-israel/0000018d-3b8c-d35c-a39f-bbdeb1de0000)

`
};